import React from "react";

const TagIcon = ({ color = "#424242", ...props }) => (
  <svg width={26} height={26} {...props}>
    <path
      fill={color}
      d="M0 12.803V2.438A2.437 2.437 0 0 1 2.438 0h10.365c.646 0 1.266.257 1.723.714l10.76 10.76a2.438 2.438 0 0 1 0 3.447L14.921 25.286a2.438 2.438 0 0 1-3.447 0L.714 14.526A2.438 2.438 0 0 1 0 12.803zM5.688 3.25a2.437 2.437 0 1 0 0 4.875 2.437 2.437 0 0 0 0-4.875z"
    />
  </svg>
);

export default TagIcon;
